import { CheckbookIcon } from './CheckbookIcon';

/**
 * author: Google
 * id F35E17AA-A0E8-4AEE-9504-6DC07F3ACEAD
 * name checkbook
 * version: 2.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/checkbook.svg
 * tags
 * - Banking 
 */
export const ChequebookIcon = CheckbookIcon;
export default ChequebookIcon